module.exports = __webpack_public_path__ + "static/media/icon-search.f9ef371e.png";